import { connect } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useState, useMemo, useEffect, useCallback } from 'react';
import DataSource from 'devextreme/data/data_source';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { duotone } from '@fortawesome/fontawesome-svg-core/import.macro';
import ArrayStore from "devextreme/data/array_store";
import WidgetTools from "./widgetTools";
import { removeWidget } from "src/redux/supervisorSlice";
import WidgetSettings from "./widgetSettings"
import MonitorWSService from 'src/services/monitorwsservice';
import { selectionTypes } from "src/components/utils/consts";
import {
    DataGrid, Column, StateStoring, Paging, Sorting, SearchPanel, Scrolling
} from 'devextreme-react/data-grid';
import { seconds2HMS } from '../utils/utils';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import GroupStatusModal from '../misc/groupStatusModal';


function GroupsStats(props) {

    const [groups, setGroups] = useState(0);
    const [showSettings, setShowSettings] = useState(false);
    const [selectedGroups, setSelectedGroups] = useState([]);
    const [showConfirmation, setShowConfirmation] = useState(false);
    const [selected, setSelected] = useState(null);
    const [type, setType] = useState(null);

    const dataSource = useMemo(() => {
        return new DataSource({
            store: new ArrayStore({
                key: 'groupId',
                data: []
            }),
            reshapeOnPush: true
        })
    }, []);

    const { t } = useTranslation();

    useEffect(() => {
        // component mounts
        return () => {
            // component unmounts
            if (MonitorWSService?.stompClient?.connected) {
                MonitorWSService.stompClient.send("/app/unsubscribe/queuesstatus", {}, JSON.stringify({
                    token: props.token,
                }));

                MonitorWSService.stompClient.unsubscribe("queuesstatus");
            }
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {

        if (props.connected) {

            let selectedGroups = JSON.parse(localStorage.getItem(`GroupsStats_groups_${props.identifier}_user${props.id}`) || "[]");
            setSelectedGroups(selectedGroups);

            MonitorWSService.stompClient.send("/app/subscribe/queuesstatus", {}, JSON.stringify({
                token: props.token,
                groupsIds: selectedGroups
            }));

            MonitorWSService.stompClient.subscribe(`/user/${props.token}/topic/queuesstatus/`, updateState, { id: "queuesstatus" });

        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.connected]);

    const closeWidget = (e) => {
        e.preventDefault();
        props.close(props.identifier);
    }

    const toggleSettings = () => {
        setShowSettings(!showSettings);
    };

    const toggleConfirmation = () => {
        setShowConfirmation(!showConfirmation);
    };

    const selectGroups = (groups) => {
        setShowSettings(!showSettings);
        setSelectedGroups(groups);
        localStorage.setItem(`GroupsStats_groups_${props.identifier}_user${props.id}`, JSON.stringify(groups));
        MonitorWSService.stompClient.send("/app/subscribe/queuesstatus", {}, JSON.stringify({
            token: props.token,
            groupsIds: groups
        }));
    };

    const renderDuration = useCallback(e => <span>{seconds2HMS(e.value)}</span>, []);

    const updateState = (groups) => {
        if (!document.hidden) {
            let data = JSON.parse(groups.body);
            let groupIds = dataSource.items().map(x => x.groupId);

            groupIds.forEach(x => {
                if (data.map(c => c.groupId).indexOf(x) === -1) {
                    dataSource.store().push([{ type: 'remove', key: x }]);
                }
            });

            data.forEach(v => {
                if (groupIds.indexOf(v.groupId) > -1) {
                    dataSource.store().push([{ type: 'update', key: v.groupId, data: v }]);
                } else {
                    dataSource.store().push([{ type: 'insert', data: v }]);
                }
            });
            setGroups(data.length);
        }
    }

    const renderGroupMode = useCallback(e => {
        let content = <FontAwesomeIcon className="px-1 text-warning" size="lg" icon={duotone("hand")} />;
        let data = e.data;
        if (e.value)
            content = <FontAwesomeIcon className="px-1 text-success" size="lg" icon={duotone("arrows-rotate")} />

        return (<OverlayTrigger
            placement="bottom"
            delay={{ show: 250, hide: 400 }}
            overlay={<Tooltip style={{ position: "fixed" }}>
                {t((e.value ? "automatic" : "manual"))}
            </Tooltip>}>
            {
                <div onClick={ev => changeMode(data)} style={{ cursor: e.value ? "" : "pointer" }}>{content}</div>
            }

        </OverlayTrigger>
        );
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const changeMode = (data) => {
        setSelected(data);
        toggleConfirmation();
        setType("mode");
    }

    const changeState = (data) => {
        setSelected(data);
        toggleConfirmation();
        setType("state");
    }
    const renderGroupStatus = useCallback(e => {
        let content = <FontAwesomeIcon className="px-1 text-danger" size="lg" icon={duotone("toggle-large-off")} />
        let data = e.data;
        if (e.value)
            content = <FontAwesomeIcon className="px-1 text-success" size="lg" icon={duotone("toggle-large-on")} />

        return <OverlayTrigger
            placement="bottom"
            delay={{ show: 250, hide: 400 }}
            overlay={<Tooltip style={{ position: "fixed" }}>
                {t((e.value ? "open" : "closed"))}
            </Tooltip>}
        ><div style={{ cursor: "pointer" }} onClick={ev => changeState(data)}>{content}</div>
        </OverlayTrigger>;
        // eslint-disable-next-line react-hooks/exhaustive-deps     
    }, [t]);

    return (
        <div className={"card card-flush overflow-hidden h-lg-20 widget-container"} id="groupsstatswidget">

            <div className="card-header">
                <h3 className="card-title align-items-start flex-column text-primary drag-handle">
                    <span className="card-label fw-bold text-primary"><FontAwesomeIcon icon={duotone("object-group")} /> {t("groupsstats")} <span className="badge badge-light-primary fs-base">{groups.length}</span></span>
                </h3>
                <div className="card-toolbar" style={{ zIndex: 9999 }}>
                    <WidgetTools key={`tools_${props.identifier}`} closeWidget={closeWidget} toggleSettings={toggleSettings}></WidgetTools>
                </div>
            </div>

            <div className="card-body" style={{ padding: "0px", height: "360px" }} >

                <DataGrid
                    id="groupsstatstable"
                    dataSource={dataSource}
                    showBorders={false}
                    columnAutoWidth={true}
                    width={"100%"}
                    height={"100%"}
                    allowColumnResizing={true}
                    loadPanel={{ enabled: false }}
                    rtlEnabled={props.rtl}
                    repaintChangesOnly={true}
                >
                    <Sorting mode={"single"} />
                    <StateStoring
                        enabled={true}
                        type="localStorage"
                        storageKey={`groupsStatsTable_${props.identifier}_user${props.id}`}
                    />
                    <Paging enabled={false} />
                    <SearchPanel
                        visible={true}
                        width={240}
                        placeholder={t("search")}
                    />
                    <Scrolling
                        rowRenderingMode={"virtual"}
                        columnRenderingMode={"virtual"}
                    ></Scrolling>
                    <Column cssClass={"align-middle"} dataField="groupId" visible={false} showInColumnChooser={false} />
                    <Column cssClass={"align-middle"} dataField="groupName" caption={t("group")} width={100} />
                    <Column cssClass={"align-middle"} dataField="opened" cellRender={renderGroupStatus} caption={t("status")} width={100} />
                    <Column cssClass={"align-middle"} dataField="automatic" cellRender={renderGroupMode} caption={t("mode")} width={100} />
                    <Column cssClass={"align-middle"} dataField="calls" caption={t("calls")} width={100} />
                    <Column cssClass={"align-middle"} dataField="answeredCalls" caption={t("attended")} width={100} />
                    <Column cssClass={"align-middle"} dataField="missedCalls" caption={t("missed")} width={100} />
                    <Column cssClass={"align-middle"} dataField="answeredCallsPercentage" caption={t("attended") + "%"} cellRender={e => e.value + "%"} width={100} />
                    <Column cssClass={"align-middle"} dataField="queueCalls" caption={t("queuecalls")} width={100} />
                    <Column cssClass={"align-middle"} dataField="maxTimeInQueue" caption={t("maxqueuetime")} cellRender={renderDuration} width={100} />
                    <Column cssClass={"align-middle"} dataField="averageWaitingTime" caption={t("averagewaitingtime")} cellRender={renderDuration} width={100} />
                </DataGrid>
            </div>

            <WidgetSettings key={`settings_${props.identifier}`} showSettings={showSettings} toggleSettings={toggleSettings} token={props.token} setGroups={selectGroups} groups={selectedGroups} selectionType={selectionTypes.GROUPMULTIPLE}></WidgetSettings>
            <GroupStatusModal show={showConfirmation} toggleModal={toggleConfirmation} selected={selected} type={type}></GroupStatusModal>
        </div>
    );
}

const mapStateToProps = (state) => {
    return {
        token: state.supervisor.token,
        id: state.supervisor.id,
        rtl: state.parameters.rtl,
        connected: state.parameters.connected
    };
};

export default connect(mapStateToProps, { removeWidget })(GroupsStats);